import { Navigate } from "react-router";

export function SelectExercise() {
  return <Navigate to="/shopselect" replace />;
}
